import React, { useEffect, useRef, useState } from "react";
import ButtonActionIcon from "../ButtonActionIcon";
import useClickOutside from "../../../hooks/useClickOutside";
import MaterialIcon from "../MaterialIcon";
import IconSelector from "../IconSelector/IconSelector";

const IconPreview = ({ icon, className = "", customStyle = {}, onClick }) => {
  return (
    <MaterialIcon
      name={icon?.split(" ")[0]}
      className={className}
      style={customStyle}
      onClick={() => onClick && onClick()}
    />
  );
};

const AddAndDeleteInlineIcon = ({ icon, callbackFunction, modalStyle = {} }) => {
  const [isIconsOpen, setIsIconsOpen] = useState(false);
  const popupOptionDivRef = useRef();
  useClickOutside(popupOptionDivRef, () => setIsIconsOpen(false));

  return (
    <>
      {icon ? (
        <div className="inline_icon_action_preview input_icon_wrapper">
          <IconPreview className="label_icon" icon={icon || ""} />
          <ButtonActionIcon className="icon_delete_inline" type="delete" onClick={() => callbackFunction("")} />
        </div>
      ) : (
        <div className="inline_icon_action_preview position_relative" ref={popupOptionDivRef}>
          <ButtonActionIcon type={"add"} onClick={() => setIsIconsOpen(true)} />
          <div className="position_absolute" style={{ left: "0px", top: "30px", width: "320px", zIndex: "100" }}>
            {isIconsOpen && (
              <IconSelector
                callbackFunction={(data) => callbackFunction(data)}
                customStyle={modalStyle}
                onClose={() => setIsIconsOpen(false)}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};

function NewIconSelector({ icon, onChange }) {
  const [isIconSelectorOpen, setIsIconSelectorOpen] = useState(false);
  const wrapperRef = useRef(null);

  const openIconSelector = () => setIsIconSelectorOpen(true);
  const closeIconSelector = () => setIsIconSelectorOpen(false);

  const deleteIcon = (e) => {
    e.stopPropagation();
    onChange("");
  };

  const showIcon = icon || "add";

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        closeIconSelector();
      }
    };

    if (isIconSelectorOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isIconSelectorOpen]);

  return (
    <div ref={wrapperRef} className="position_relative">
      <div className="d_flex position_relative">
        <div
          className="p_2 bg_light d_flex align_center justify_center border_radius_small position_relative cursor_pointer"
          onClick={openIconSelector}
        >
          <IconPreview icon={showIcon} />
          {icon && (
            <MaterialIcon
              name="close"
              className="cursor_pointer position_absolute font_size_xsmall bg_danger color_light border_radius_large p_small"
              onClick={deleteIcon}
              style={{
                right: "-6px",
                top: "-6px"
              }}
            />
          )}
        </div>
      </div>
      {isIconSelectorOpen && (
        <div className="icon_selector_wrapper">
          <div className="icon_selector_close_button" onClick={closeIconSelector}>
            <span className="material-symbols-outlined">close</span>
          </div>

          <IconSelector callbackFunction={(data) => onChange(data)} />
        </div>
      )}
    </div>
  );
}

export { AddAndDeleteInlineIcon, NewIconSelector };

export default IconPreview;
